import { useLang } from '@/i18n';
import styles from './index.module.scss';

export default function TipComp() {
    const { t } = useLang('OceanProHomeSolarBattery');

    return (
        <div
            className={`${styles.topTip}`}
            onClick={() => {
                window.open('https://www.ecoflow.com/us/incentives-and-policy');
            }}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path
                    d="M8.4817 2.31055C8.80514 2.29908 9.11899 2.4226 9.34791 2.65137L14.6047 7.90723C15.0601 8.36277 15.0601 9.10204 14.6047 9.55762L9.89088 14.2715C9.43532 14.727 8.6961 14.7269 8.24049 14.2715L2.98365 9.01465C2.75504 8.7857 2.63228 8.4718 2.64381 8.14844L2.82838 2.97656C2.83796 2.71472 3.04795 2.5046 3.30983 2.49512L8.4817 2.31055ZM3.8108 3.47754L3.64186 8.18457C3.64032 8.2304 3.65843 8.27504 3.69069 8.30762L8.94752 13.5645C9.01261 13.6294 9.11881 13.6294 9.18385 13.5645L13.8977 8.85059C13.9625 8.78553 13.9626 8.67928 13.8977 8.61426L8.64088 3.3584C8.60819 3.32586 8.56297 3.30695 8.51686 3.30859L3.8108 3.47754ZM6.64088 5.5127C6.94456 5.57482 7.17292 5.84402 7.17311 6.16602C7.17311 6.48814 6.94461 6.75712 6.64088 6.81934L6.50709 6.83301H6.50026C6.13207 6.83301 5.83326 6.53421 5.83326 6.16602C5.83348 5.79801 6.1322 5.49902 6.50026 5.49902H6.50709L6.64088 5.5127Z"
                    fill="white"
                />
            </svg>
            <div className="top-desc">{t('top_desc')}</div>
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
                <path d="M6.5 4L10.5 8L6.5 12" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
    );
}
